export enum TripType {
  RETURN = 'return',
  ONEWAY = 'oneway',
  MULTICITY = 'multicity',
}
